import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";

var _effectorFileName = "/builds/gmini/front-common/src/components/FilterPanel/components/FilterConditionItem/FilterConditionItem.tsx",
    _styled;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { ArrowDown, VirtualizedAutocomplete } from '@gmini/ui-kit';
import { ClickAwayListener } from '@mui/base/ClickAwayListener';
import { Box, TextField, autocompleteClasses, paperClasses } from '@mui/material';
import { useCallback, useRef, useState, useEffect } from 'react';
import { styled } from '@mui/styles';
import { RenderOption } from "../RenderOption/RenderOption";
import { Button, Popper } from "./FilterConditionItem.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-types
export var FilterConditionItem = function FilterConditionItem(_ref) {
  var label = _ref.label,
      _getOptionLabel = _ref.getOptionLabel,
      options = _ref.options,
      _onChange = _ref.onChange,
      value = _ref.value,
      filled = _ref.filled,
      searchable = _ref.searchable,
      disabled = _ref.disabled,
      renderOptionIcon = _ref.renderOptionIcon,
      error = _ref.error,
      _ref$freeSolo = _ref.freeSolo,
      freeSolo = _ref$freeSolo === void 0 ? true : _ref$freeSolo,
      onClickAway = _ref.onClickAway,
      isOptionEqualToValue = _ref.isOptionEqualToValue;
  var inputRef = useRef(null);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      inputValue = _useState4[0],
      setInputValue = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      currentLabel = _useState6[0],
      setCurrentLabel = _useState6[1];

  useEffect(function () {
    setCurrentLabel(_getOptionLabel(value));
  }, [value, _getOptionLabel]);

  var handleClick = function handleClick(event) {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  var onClickAwayHandler = function onClickAwayHandler() {
    onClickAway === null || onClickAway === void 0 ? void 0 : onClickAway({
      value: value,
      inputValue: inputValue
    });
    handleClose();
  };

  var renderOption = useCallback(function (_, option) {
    return /*#__PURE__*/_jsx(RenderOption, {
      getOptionLabel: _getOptionLabel,
      option: option,
      renderOptionIcon: renderOptionIcon
    });
  }, [_getOptionLabel, renderOptionIcon]);
  var renderInput = useCallback(function (params) {
    return /*#__PURE__*/_jsx(FilterConditionTextField, _objectSpread(_objectSpread({
      autoFocus: true,
      inputRef: inputRef,
      searchable: searchable,
      ref: params.InputProps.ref,
      value: inputValue,
      onChange: function onChange(e) {
        return setInputValue(e.target.value);
      },
      error: error
    }, params), {}, {
      inputProps: _objectSpread({}, params.inputProps)
    }));
  }, [error, inputValue, searchable]);
  var open = Boolean(anchorEl);
  var id = open ? 'simple-popper' : undefined;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Button, {
      filled: filled,
      color: "secondary",
      rightIcon: open ? /*#__PURE__*/_jsx(ArrowDown, {
        transform: "rotate(180)"
      }) : /*#__PURE__*/_jsx(ArrowDown, {}),
      onClick: handleClick,
      disabled: disabled,
      selected: open,
      error: error,
      children: value ? currentLabel : label
    }), /*#__PURE__*/_jsx(Popper, {
      id: id + label,
      open: open,
      anchorEl: anchorEl,
      placement: "bottom-start",
      filled: filled,
      children: /*#__PURE__*/_jsx(ClickAwayListener, {
        onClickAway: onClickAwayHandler,
        children: /*#__PURE__*/_jsx(Box, {
          sx: {
            marginTop: filled ? '12px' : '4px'
          },
          children: /*#__PURE__*/_jsx(FilterConditionAutoComplete, {
            open: true,
            freeSolo: freeSolo,
            value: value,
            noOptionsText: "\u041D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0445 \u0441\u0432\u043E\u0439\u0441\u0442\u0432",
            sx: {
              '.MuiAutoComplete-root': {
                border: '1px solid red'
              }
            },
            onChange: function onChange(event, value, reason, details) {
              var currentValue = value;
              var currentDetails = details;

              if (value) {
                _onChange({
                  event: event,
                  value: currentValue,
                  reason: reason,
                  details: currentDetails
                });

                handleClose();
              }
            },
            options: options,
            renderOption: renderOption,
            renderInput: renderInput,
            isOptionEqualToValue: isOptionEqualToValue ? function (option, value) {
              return isOptionEqualToValue(option, value);
            } : undefined,
            PopperComponent: function PopperComponent(props) {
              return /*#__PURE__*/_jsx(FilterConditionPopper, _objectSpread(_objectSpread({}, props), {}, {
                placement: "bottom-start"
              }));
            },
            getOptionLabel: function getOptionLabel(currentOption) {
              if (currentOption) {
                var _label = _getOptionLabel(currentOption);

                return _label;
              }

              return '';
            }
          })
        })
      })
    })]
  }, label);
};
var FilterConditionPopper = styled(Popper)((_styled = {
  padding: 0
}, _defineProperty(_styled, "& .".concat(paperClasses.root), {
  boxShadow: '0px 5px 10px rgb(53 60 96 / 15%) !important',
  border: '1px solid #EDEFF3 !important',
  borderRadius: '4px',
  margin: '2px -3px 0 0',
  fontSize: '14px',
  fontWeight: 500,
  color: '#353B60',
  minWidth: '200px'
}), _defineProperty(_styled, "& .".concat(autocompleteClasses.noOptions), {
  color: '#353B60',
  padding: '10px 8px 10px 12px',
  cursor: 'default',
  fontWeight: 500,
  fontSize: '14px'
}), _styled));
var FilterConditionTextField = styled(TextField)(function (_ref2) {
  var searchable = _ref2.searchable;
  return {
    '& .MuiOutlinedInput-root': {
      display: searchable ? 'inherit' : 'none',
      boxShadow: '0px 5px 10px rgba(53, 60, 96, 0.1)',
      height: '40px',
      minWidth: '200px',
      gap: '8px ',
      padding: '0 10px !important',
      background: 'inherit',
      border: '1px solid #4C5ECF',
      transition: 'border-color ease-out .2s',
      backgroundColor: '#fff',
      '& .MuiAutocomplete-tag': {
        padding: 0,
        margin: 0
      },
      '&:hover': {
        border: '1px solid #4C5ECF'
      },
      '& .MuiAutocomplete-clearIndicator': {
        display: 'flex',
        alignItems: 'center',
        '& path': {
          opacity: 0.25
        },
        '&:hover': {
          background: 'none',
          '& path:first-child': {
            opacity: 1,
            fill: '#353b60'
          }
        },
        '&:active, &:focus': {
          '& path:first-child': {
            opacity: 1,
            fill: '#00003d'
          }
        }
      },
      '& .MuiAutocomplete-endAdornment': {
        top: '5.5px'
      },
      '& input': {
        fontSize: '14px',
        fontWeight: 500,
        color: 'rgba(0, 0, 0, 0.87)',
        paddingLeft: '2px !important'
      },
      '& input::placeholder': {
        fontWeight: 500,
        fontSize: '13px',
        color: 'rgba(0, 3, 53, 1)'
      }
    }
  };
});
var FilterConditionAutoComplete = styled(VirtualizedAutocomplete)(function (_ref3) {
  var focusedInput = _ref3.focusedInput;
  return {
    '& .MuiAutocomplete-listbox': {
      maxHeight: '70vh'
    },
    '& .MuiAutocomplete-root': {
      '& .MuiAutocomplete-input': {
        color: '#353B60'
      },
      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
        borderRadius: '4px',
        boxShadow: focusedInput ? '0px 5px 10px rgba(53, 60, 96, 0.1)' : 'none',
        transition: 'background-color .2s ease-out, border-color .2s ease-out, box-shadow .2s ease-out'
      }
    },
    '& .MuiInputBase-root': {
      cursor: 'default'
    },
    '& .MuiAutocomplete-input': {
      color: '#353B60'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
      borderRadius: '4px',
      boxShadow: focusedInput ? '0px 5px 10px rgba(53, 60, 96, 0.1)' : 'none',
      transition: 'background-color .2s ease-out, border-color .2s ease-out, box-shadow .2s ease-out'
    },
    '& .MuiAutocomplete-clearIndicator': {
      display: 'none'
    }
  };
});